import React from "react"
import { graphql /*Link*/ } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const Blog = ({ data /* pageContext, location */ }) => {
  const post = data.markdownRemark
  // const { next, prev } = pageContext
  return (
    <Layout>
      <SEO title={post.frontmatter.title} />
      <div
        class="hero-section blog-post d-section"
        style={{
          backgroundSize: "100%",
        }}
      >
        <div class="hero-wrapper other">
          <div class="hero-container">
            <div class="hero-content">
              <h1 class="hero-h1">{post.frontmatter.title}</h1>
              <p class="hero-p">{post.frontmatter.description}</p>
              <a href="#more" class="btn-small w-button">
                Read More
              </a>
            </div>
          </div>
        </div>
      </div>
      <div id="more" class="section">
        <div class="container bl">
          <div class="rich-text-block w-richtext">
            <div
              id="blog-body"
              className="blog-body"
              dangerouslySetInnerHTML={{ __html: post.html }}
            ></div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Blog

export const query = graphql`
  query($slug: String!) {
    markdownRemark(frontmatter: { path: { eq: $slug } }) {
      id
      frontmatter {
        title
        path
        date
        description
        image
        # {
        #   childImageSharp {
        #     fluid(maxWidth: 800) {
        #       ...GatsbyImageSharpFluid
        #     }
        #   }
        # }
        imagedescription
      }
      html
      #   timeToRead
    }
  }
`
